import React from 'react';
import RequestAbsences from '../../../components/absence/RequestAbsencesMobile/RequestAbsencesMobile';

const RequestAbsencesMobile = () => {
    return (
            <RequestAbsences />
    );
};

export default RequestAbsencesMobile;